<template>
    <div :class="style.tableContainer">
        <slot name="prepend"></slot>
        <slot></slot>
        <slot name="append"></slot>
    </div>
</template>

<script>
    import Vue from 'vue'
    import oldstyle from './style.module.scss'
    import newstyle from './newstyle.module.scss'

    export default Vue.extend({
        name: 'table-container',
        components: {

        },
        props: {
            nameStyle: {
                type: String,
                required: false
            }
        },
        data() {
               return { 
                   style: this.nameStyle==='old' ? oldstyle : newstyle
                }
            },
    })
</script>